<template>
  <div id="app" :style="{ height: windowHeight + 'px' }">
    <Home />
  </div>
</template>

<script>
import Home from '@/views/Home.vue'

export default {
  name: 'App',
  components: {
    Home
  },
  data() {
    return {
      windowHeight: window.innerHeight
    }
  },
  created() {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() { this.windowHeight = window.innerHeight }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  position: absolute;
  width: 100vw;
  top: 0;
  left: 0;
}

#explore {
  position: absolute;
  display: flex;
  width: 400px;
  top: 0;
  left: 0;
  gap: 10px;
  margin-top: 20px;
  margin-left: 20px;
  flex-direction: column;
}

@media (max-width: 768px) {
  #explore {
    width: 100vw;
    left: 0; 
    right: 0;
    margin: 0;
  }
}
</style>